import { Yii } from "libraries/interfaces/Yii";
import { ILabels } from "libraries/interfaces/ILabels";

export const LABELS: ILabels = {
    whenLastUpdated: Yii.t("wui-sasha-js", "Dernière mise à jour"),
};
